exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".v-pagination__item[data-v-2eaa7384],.v-pagination__item--active[data-v-2eaa7384],.v-pagination__navigation[data-v-2eaa7384]{box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 2px 0 rgba(0,0,0,.12)}.v-btn:not(.v-btn--round).v-size--default[data-v-2eaa7384]{padding:0 20px}.v-btn.secondary[data-v-2eaa7384]{border:2px solid var(--v-neutral-2-base)!important;background-color:var(--v-white-base)!important;color:var(--v-neutral-4-base)!important}", ""]);

// exports
